'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    StarsView: {
        displayName: 'StarsView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/Stars/default/StarsView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var StarsView = _wrapComponent('StarsView')(function (_Component) {
    (0, _inherits3.default)(StarsView, _Component);

    function StarsView() {
        (0, _classCallCheck3.default)(this, StarsView);
        return (0, _possibleConstructorReturn3.default)(this, (StarsView.__proto__ || (0, _getPrototypeOf2.default)(StarsView)).apply(this, arguments));
    }

    (0, _createClass3.default)(StarsView, [{
        key: 'render',
        value: function render() {
            // todo количество звезд получить с API, их количество отображать по какой-то логике (с) Илья
            return _react3.default.createElement(
                'div',
                { className: 'star-holder inline' },
                _react3.default.createElement(
                    'div',
                    { className: 'star', 'data-score': '4' },
                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
                    _react3.default.createElement('img', { src: '../assets/images/star-off.png', alt: '1' })
                )
            );
        }
    }]);
    return StarsView;
}(_react2.Component));

exports.default = StarsView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Stars/default/StarsView.jsx
// module id = 1639
// module chunks = 0